import actionTypes from './../../../redux/actions/action-types';

export const setAction = (data) => ({
  type: actionTypes.billingHistoryPage.set,
  data,
});

export const getAdjustmentsAction = (data) => ({
  type: actionTypes.billingHistoryPage.getAdjustments,
  data,
});

export const getSubHistoryAction = (data) => ({
  type: actionTypes.billingHistoryPage.getSubHistory,
  data,
});

export const downloadInvoiceAction = (data) => ({
  type: actionTypes.billingHistoryPage.downloadInvoice,
  data,
});
